import { Provider } from '@angular/core';

import {
  AuthenticateUserUseCase,
  GetMasterTokenUseCase,
  LoginUseCase,
  RemoveMasterTokenUseCase,
  SetMasterTokenUseCase,
} from '@application/use-cases';
import { AuthRepository, TokenRepository } from '@domain/repositories';
import { AuthRepositoryImpl, TokenRepositoryImpl } from '../repositories';

// The dependency injection wiring
export const AUTH_PROVIDERS: Provider[] = [
  // Repositories
  { provide: AuthRepository, useClass: AuthRepositoryImpl },
  { provide: TokenRepository, useClass: TokenRepositoryImpl },
  {
    provide: GetMasterTokenUseCase,
    useFactory: (tokenRepo: TokenRepository) =>
      new GetMasterTokenUseCase(tokenRepo),
    deps: [TokenRepository],
  },
  {
    provide: SetMasterTokenUseCase,
    useFactory: (tokenRepo: TokenRepository) =>
      new SetMasterTokenUseCase(tokenRepo),
    deps: [TokenRepository],
  },
  {
    provide: RemoveMasterTokenUseCase,
    useFactory: (tokenRepo: TokenRepository) =>
      new RemoveMasterTokenUseCase(tokenRepo),
    deps: [TokenRepository],
  },
  {
    provide: LoginUseCase,
    useFactory: (authRepo: AuthRepository) => new LoginUseCase(authRepo),
    deps: [AuthRepository],
  },
  {
    provide: AuthenticateUserUseCase,
    useFactory: (authRepo: AuthRepository) =>
      new AuthenticateUserUseCase(authRepo),
    deps: [AuthRepository],
  },
];
